<template>
  <div>
    <CRow>
      <CCol md="12">
        <CForm>
          <CCard>
            <CCardHeader class="p-1">
              <CRow>
                <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                  <strong>{{ get_document_type_label }}</strong>

                </CCol>
                <CCol col="4" style="text-align: end">
<!--                  <CButton v-if="status_form==0" @click="insert_data_factor()" size="sm"-->
<!--                           color="secondary">-->
<!--                    {{ $t('preview') }}-->
<!--                  </CButton>-->


<!--                  <CButton v-if="status_form!=0" @click="insert_data_factor()" size="sm"-->
<!--                           color="secondary">-->
<!--                    <CIcon size="sm" name="cil-check-circle"/>-->
<!--                    {{ $t('buttons.editDocument') }}-->
<!--                  </CButton>-->
                  <CButton v-if="status_form==0 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_factor()"
                           size="sm"
                           color="secondary">
                    {{ $t('preview') }}
                  </CButton>
                  <CButton v-if="status_form==0  && is_year_closed()" class="mr-1 ml-1"
                           @click="year_closed_dialog()" type="submit"
                           size="sm" color="danger">
                    {{ $t('preview') }}
                  </CButton>


                  <CButton v-if="status_form!=0 && !is_year_closed()" @click="insert_data_factor()" size="sm"
                           color="secondary">
                    {{ $t('buttons.editDocument') }}
                  </CButton>
                  <CButton v-if="status_form!=0  && is_year_closed()" class="mr-1 ml-1"
                           @click="year_closed_dialog()" type="submit"
                           size="sm" color="danger">
                    {{ $t('buttons.editDocument') }}
                  </CButton>
                  <CButton
                      class="mr-1"
                      size="sm"
                      color="secondary"
                  >{{ $t("buttons.cancel") }}
                  </CButton>

                  <a :href="$route.fullPath" target="_blank">
                    <CButton
                        class="mr-1 ml-1"
                        size="sm"
                        color="dark"
                    >
                      <CIcon size="sm" name="cil-plus"></CIcon>
                    </CButton>
                  </a>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow>


                <CCol col="3">
                  <CRow form class="form-group">
                    <CCol tag="label" sm="3" class="col-form-label">
                      {{ $t('components.seller') }}
                    </CCol>
                    <CCol sm="8">
                      <treeselect
                          :cacheOptions="false"
                          v-model="document_person"
                          :async="async_person_search"
                          :options="async_person_options"
                          @select="select_person"
                          :load-options="load_persons"
                          :placeholder="$t('search')"
                          :normalizer="normalizer_persons"
                      />

                    </CCol>
                    <CCol col="1" class="m-0">
                      <CButton v-if="document_person!=null" :href="'/dashboard/orders/edit-supplier/'+document_person"
                               target="_blank" color="dark"
                               size="sm">
                        <CIcon size="sm" name="cil-user"/>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCol>

                <CCol col="3">

                  <CSelect
                      :options="[{label:this.$t('inLocation'),value:21},{label:this.$t('inBranch'),value:22}]"
                      :label="$t('deliveryType')"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      :value.sync="delivery_type"
                  />
                </CCol>
                <CCol col="3">
                  <CSelect
                      :options="places_items"
                      :label="$t('inventory')"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      :value.sync="selected_place"
                  />
                </CCol>
                <CCol col="3">
                  <div>
                    <CRow form class="form-group">
                      <CCol tag="label" sm="4" class="col-form-label">
                        {{ $t('components.date') }}
                      </CCol>
                      <CCol sm="8">
                        <date-picker
                            v-model="date"
                            :min="fyear_min_date"
                            :max="fyear_max_date"
                        ></date-picker>
                      </CCol>
                    </CRow>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol col="4" style="padding: 1px">
                  <CRow form class="form-group">
                    <CCol col="" tag="label" class="col-form-label">
                      {{ $t('payTypeCash') }}
                    </CCol>
                    <CCol col="4">
                      <CSelect
                          :options="pay_type_items"
                          :value.sync="selected_pay_type"
                      />
                    </CCol>
                    <CCol col="4">
                      <CSelect v-if="selected_pay_type!=35"
                               :options="cashiers"
                               :value.sync="selected_cashiers"
                      />

                    </CCol>
                  </CRow>

                </CCol>


                <CCol style="padding: 1px">
                  <CSelect
                      :options="currency_items2"
                      :label="$t('currency')"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      :disabled="product_items.length>1"
                      :value.sync="selected_currency"
                  />
                </CCol>
                <CCol style="padding: 1px">
                  <CInputCurrency
                      :label="$t('ratio')"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="currency_rate"
                  />
                </CCol>
                <CCol style="padding: 1px">
                  <CInput
                      :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                      v-model="product_location"
                      v-on:keypress="isEnglish($event)"

                      :label="$t('productLocation')"
                  />
                </CCol>
                <CCol>
                  <CTextarea
                      :label="$t('components.documentSummary')"
                      :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"

                      v-model="document_summary"

                      rows="1"
                  />
                </CCol>
              </CRow>

              <div style="min-height: 250px" class="overflow-auto">
                <CDataTableFixed
                    :items="product_items"
                    :fields="product_fields"
                    @row-clicked="table_row_clicked"
                    :items-per-page="200"
                    hover
                    sorter
                    :sticky_zero="true"

                    height="250px"
                    pagination
                >
                  <template #row="{item,index}">

                    <td>
                      <p v-if="index!=0">{{ item.row_id }}</p>

                    </td>

                  </template>
                  <template #name="{item,index}">

                    <td v-if="index==0">
                      <CRow style="padding-right: 7px;padding-left:7px">
                        <CCol col="10" class="m-0 p-0">
                          <treeselect
                              :cacheOptions="false"
                              v-model="selected_product"
                              v-if="status_product_form==-1"
                              ref="product_searcher"
                              id="product_seeker"
                              :async="true"
                              :appendToBody="true"
                              @select="select_product"
                              :load-options="load_products"
                              :placeholder="$t('searchItem')"
                              :normalizer="normalizer_products"
                          />
                          <label v-else>{{ product_name }}</label>
                        </CCol>
                        <CCol col="2" class="m-0 p-0">
                          <CButton style="height: 100%;" v-if="selected_product!=null"
                                   size="sm" outline color="dark"
                                   @click="open_selected_product()">
                            <CIcon size="sm" name="cil-cart"/>
                          </CButton>

                        </CCol>
                      </CRow>
                    </td>

                    <td v-else>
                      <p>{{ item.name }}</p>

                    </td>

                  </template>

                  <template #unit="{item}">

                    <td>
                      <p>{{ item.unit_value_name }}</p>

                    </td>

                  </template>

                  <template #count="{item,index}">

                    <td v-if="index==0">
                      <CInput
                          :whitout_decimal="true"

                          :placeholder="$t('components.productQty')"
                          v-on:keyup.enter="another_focus('product_price_input')"
                          id="product_qty_input"
                          @keypress="isDecimal_no_fix(e,product_count)"

                          v-model="product_count"
                      />
                    </td>

                    <td v-else>
                      <p>{{ get_currency(item.count) }}</p>

                    </td>

                  </template>
                  <template #price="{item,index}">

                    <td v-if="index == 0">
                      <CInput v-on:keyup.enter="another_focus('input_off')"

                              :placeholder="$t('components.unitPrice')"
                              @keypress="isDecimal_no_fix(e,product_price)"
                              id="product_price_input"

                              v-model="product_price"
                      >

                      </CInput>

                    </td>
                    <td v-else>
                      <p style="float: right">
                        {{ get_currency(item.price) }}</p>

                    </td>

                  </template>
                  <template #totalPrice="{item ,index}">

                    <td>
                      <p style="float: right" v-if="index !=0">
                        {{
                        get_currency(calculate_total_price(item))
                        }} </p>
                      <p class="text-center pt-1" v-if="index ==0 && selected_product!=null">
                        {{ $t('SaleableQty') }}: {{
                        get_currency_no_fix(parseInt(product_existance/product_unit_value))
                        }}</p>

                    </td>
                  </template>

                  <template #totalPriceCurrency="{item ,index}">

                    <td>
                      <p style="float: right" v-if="index !=0">
                        {{
                        get_currency(calculate_total_price_currency(item))
                        }} </p>

                    </td>

                  </template>
                  <template #offPrice="{item,index}">
                    <td>
                      <CInputCurrency
                          :whitout_decimal="true"

                          v-on:keyup.enter="another_focus('input_tax')"
                          id="input_off"
                          v-if="index ==0"
                          v-model="product_off"
                      />
                      <p style="float: right" v-if="index !=0">
                        {{
                        get_currency(calculate_off_price(item))
                        }} </p>
                    </td>

                  </template>
                  <template #taxPrice="{item,index}">
                    <td>
                      <CInputCurrency
                          id="input_tax"
                          v-if="index ==0"
                          v-on:keyup.enter="add_product_to_document_new()"
                          v-model="product_tax"
                      >
                        <template #append-content>
                          <CIcon size="sm" name="cil-plus"
                                 @click.native="add_product_to_document_new"></CIcon>

                        </template>
                      </CInputCurrency>
                      <p style="float: right" v-if="index !=0">
                        {{
                        get_currency(calculate_tax_price(item))
                        }} </p>
                    </td>

                  </template>
                  <template #totalPayPrice="{item,index}">
                    <td>
                      <p style="float: right" v-if="index !=0">
                        {{
                        get_currency(calculate_total_pay_price(item))
                        }} </p>
                    </td>

                  </template>
                  <template #weight="{item,index}">

                    <td>
                      <p style="float: right" v-if="index !=0">
                        {{
                          get_currency((item.weight * item.count * item.unit_value))
                        }}
                      </p>

                    </td>

                  </template>
                  <template #summary="{item}">

                    <td>
                      <p>{{ item.summary }}</p>

                    </td>

                  </template>


                  <template #operation="{item,index}">
                    <td>

                      <CIcon
                          v-if="index!=0"
                          size="sm" @click.native="edit_item(item.product_id)" class="text-primary mr-1"
                          name="cil-pencil"/>
                      <CIcon
                          v-if="index!=0"
                          size="sm" @click.native="delete_item_dialog(item)"
                          class="text-danger mr-1" name="cil-trash"/>

                      <CButton v-if="status_product_form!=-1 && index==0" title="Cancel" outline
                               color="dark">
                        <CIcon class="text-white" size="sm" name="cil-x"
                               @click.native="cancel_edit_product()"></CIcon>
                      </CButton>

                    </td>
                  </template>


                </CDataTableFixed>

              </div>
              <CRow>
                <CCol>
                  <CInputCurrency :label="$t('DeliveryCost')"
                                  v-model="delivery_cost_amount"
                                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
                <CCol>
                  <CSelect :label="$t('anotherCosts')"
                           :options="cost_items"
                           :value.sync="selected_sec_cost"
                           :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  >
                    <template #append-content>
                      <CIcon size="sm" v-on:click.native="go_to_add_modal('delivery_costs')"
                             name="cil-plus"/>
                    </template>
                  </CSelect>
                </CCol>
                <CCol>
                  <CInputCurrency :label="$t('tables.amount')"
                                  v-model="sec_cost_amount"
                                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
                <CCol>
                  <CSelect :label="$t('offType')"
                           :value.sync="total_factor_off_type"
                           :options="[{label:$t('select'),value:0},{label:$t('priceOff'),value:1},{label:$t('percentOff'),value:2}]"
                           :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
                <CCol>
                  <CInputCurrency :label="$t('components.off')"
                                  v-model="total_factor_off"

                                  :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                  />
                </CCol>
              </CRow>

              <CRow>

                <CCol col="12" class="mb-3">
                  <CDataTable
                      v-if="product_items.length>1"

                      :items="document_result_price"
                      :fields="fields_total_price"
                      striped
                      border
                      :items-per-page="200"
                      hover
                      pagination
                  >

                    <template #totalPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            item.totalPrice
                          }}</strong>
                      </td>
                    </template>
                    <template #offPrice="{item}">
                      <td>
                        <strong style="float: right">{{item.offPrice}}</strong>
                      </td>
                    </template>
                    <template #factor_off="{item}">
                      <td>
                        <strong style="float: right">{{
                            get_currency(item.factor_off)
                          }}</strong>
                      </td>
                    </template>
                    <template #taxPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            item.taxPrice
                          }}</strong>
                      </td>
                    </template>
                    <template #payPrice="{item}">
                      <td>
                        <strong style="float: right">{{
                            item.payPrice
                          }}</strong>
                      </td>
                    </template>
                    <template #total_weight="{item}">
                      <td>
                        <strong style="float: right">{{
                            get_weight(item.total_weight / 1000)
                          }} {{ $t('kg') }}</strong>
                      </td>
                    </template>


                  </CDataTable>

                </CCol>
              </CRow>

            </CCardBody>

          </CCard>
        </CForm>

      </CCol>
    </CRow>
    <CRow>


    </CRow>
    <vue-context ref="menu">
      <li>
        <a href="#" @click.prevent="edit_item(product_index_clicked)">{{ $t('components.edit') }}</a>
      </li>

      <li>
        <a href="#" @click.prevent="delete_item_dialog(product_items[product_index_clicked])">{{
            $t('buttons.delete')
          }}</a>
      </li>
    </vue-context>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Vue from "vue";

import 'vue-context/src/sass/vue-context.scss';

import VueContext from 'vue-context';
import moment from 'moment-jalaali'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}

var product_items = [{id: "0"}];


export default {
  name: 'Login',
  components: {
    Treeselect,
    VueContext,
  }, props: {
    selectedType: Number
  },

  data() {
    return {
      fyear_min_date:localStorage.getItem('fyear_min_date'),
      fyear_max_date:localStorage.getItem('fyear_max_date'),
      total_factor_off_type: 1,
      total_factor_off: '',
      async_person_search: true,
      async_person_options: [],

      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      product_index_clicked: 0,
      customer_doc_name: '',
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_Weight: localStorage.getItem('weight'),
      selected_currency: 0,
      currency_rate: '1',
      document_result_price: [],
      date: '',
      product_location: '',
      delivery_type: 21,
      product_items: product_items.map((item, row_id) => {
        return {...item, row_id}
      }),

      currency_items2: [],
      cost_items: [],
      selected_first_cost: 0,
      selected_sec_cost: 0,
      delivery_cost_amount: '',
      sec_cost_amount: '',


      product_fields: [
        {key: 'row', label: "No.", _style: 'width:3%;text-align:center'},
        {key: 'name', label: this.$t('item'), _style: 'width:20%;text-align:center'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'width:10%;text-align:center'},
        {key: 'count', label: this.$t('tables.qty'), _style: 'width:3%;text-align:center'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'width:10%;text-align:center'},
        {
          key: 'totalPriceCurrency',
          label: this.$t('totalPriceCurrency'),
          _style: 'width:10%;text-align:center'
        },
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:10%;text-align:center'},
        {key: 'offPrice', label: this.$t('tables.off'), _style: 'width:7%;text-align:center'},
        {key: 'taxPrice', label: this.$t('tables.tax'), _style: 'width:10%;text-align:center'},
        {key: 'totalPayPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%;text-align:center'},
        // {key: 'summary', _style: 'width:10%;'},
        {key: 'operation', label: '', _style: 'width:6%;text-align:center'},
      ],
      // fields_total_price: [
      //   {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
      //   {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},
      // ],
      fields_total_price: [
        {key: 'type', label: "", _style: 'padding:5px;'},
        {key: 'totalPrice', label: this.$t('factorAmount'), _style: 'padding:5px;'},
        {key: 'offPrice', label: this.$t('productDiscount'), _style: 'padding:5px;'},
        {key: 'factor_off', label: this.$t('invoiceDiscount'), _style: 'padding:5px;'},

        {key: 'taxPrice', label: this.$t('vat'), _style: 'padding:5px;'},

        // {key: 'afterOffPrice', label: this.$t('priceAfterOff'), _style: 'padding:5px;'},
        {key: 'payPrice', label: this.$t('payPrice'), _style: 'padding:5px;'},
        // {key: 'beforePrice', label: this.$t('balanceBefore'), _style: 'padding:5px;'},
        // {key: 'finalPrice', label: this.$t('finalPrice'), _style: 'padding:5px;'},
        {key: 'total_weight', label: this.$t('totalWeight'), _style: 'padding:5px;'},
      ],

      selectTypes: [
        {
          value: 1,
          label: this.$t('components.buyDocument')
        },
        {
          value: 3,
          label: this.$t('components.sellDocument')
        },
        {
          value: 5,
          label: this.$t('components.firstDocument')
        },

      ],
      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),

      document_person: null,
      document_person_name: "",
      document_person_method_name: "",
      document_person_remain_amount: "",
      document_summary: '',


      product_name: '',
      product_non_off: false,

      product_existance: '',
      product_count: '',
      product_unit: '',
      product_unit_name: '',
      product_unit_value: '',
      product_weight: '',
      product_summary: '',
      product_price: '',
      product_off: '',
      product_tax: '',
      product_off_is_percent: '',

      text_input_searcher: null,

      pay_type_items: [],
      selected_pay_type: 0,

      total_price: 0,
      total_weight: 0,
      details: [],
      cashiers: [],
      selected_cashiers: 0,
      permission_group_items: [],
      selected_permission_group: 0,

      unit_items: [],
      unit_items_filtered: [],
      selected_place: 0,
      places_items: [],

      selected_product: null,
      status_product_form: -1,
      status_form: 0,
      master_id: 0,
      load_products({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },

      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', true);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  },
  computed: {

    data_units() {
      var units_data = [];
      this.unit_items_filtered.forEach((val) => {
        var obj = {label: val.unitName, value: val.id}
        units_data.push(obj);
      });
      return units_data;
    },

    get_document_type_label() {
      return this.$t('buyFactorCurrency');
      if (this.selectedType == 1) {
        return "سند خرید ارزی";
      }
      if (this.selectedType == 3) {
        return this.$t('components.sellDocument');

      }
      if (this.selectedType == 5) {
        return this.$t('components.firstDocument');
      }

    }
  },
  mounted() {
    // console.log(document.getElementById("product_seeker").children[0].children[0].children[1].children[0]);
    // this.selectedType = this.$route.params.type_id
    this.$root.root_validate_errors = [];
    this.date = this.get_today();
    bus.$on('close_add_base_modal', (data) => {
      this.get_base_data();
    });
    this.get_base_data();


    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();
        // this.cancel_edit_product()
      } else {
        this.cancel_edit_product()
        this.status_product_form = -1;
      }
    });
    bus.$on('update_price', (data) => {
      // alert(data);
      if (data == "true") {
        this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});

      } else {
        this.status_form = 0;
      }
    });

    if (this.$route.params.user_id != null) {
      this.status_form = this.$route.params.user_id;
      this.get_user_data();
    }

    if (this.$route.params.edit_doc_id != null) {
      this.status_form = this.$route.params.edit_doc_id;
      this.get_document_master();
    }
  },
  watch: {
    'total_factor_off': function () {
      this.generate_total();
    },
    'total_factor_off_type': function () {
      this.generate_total();
    },
    'product_location': function () {
      this.product_location = this.product_location.toUpperCase();
    },
    'selectedType': function () {
      if (this.selectedType == 1) {
        this.selectedTypeLabel = this.$t('components.seller');
        this.customer_doc_name = this.$t('supplier');
        this.selectedTypeQty = 1;
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.customer_doc_name = this.$t('customer');

        this.selectedTypeQty = -1;

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.customer_doc_name = this.$t('user');

        this.selectedTypeQty = 1;

      }
    },
    '$route.params.type_id': function () {
      location.reload()
    },

    'selected_product': function () {
      // this.get_product_data()
    },
    'document_person': function () {
      this.get_user_data();
    },
    'product_items': function () {
      this.generate_total()
    },
    'currency_rate': function () {
      this.generate_total()
    },
    'product_price': function () {
      if (this.product_price == ".") {
        this.product_price = "0."
      }
    },
    'product_count': function () {
      if (this.product_count == ".") {
        this.product_count = "0."
      }
    }, 'delivery_cost_amount': function () {
      if (this.delivery_cost_amount == ".") {
        this.delivery_cost_amount = "0."
      }
      this.generate_total()
    }, 'sec_cost_amount': function () {
      if (this.sec_cost_amount == ".") {
        this.sec_cost_amount = "0."
      }
      this.generate_total()

    },
  },
  methods: {
    select_person(node) {
      var valid = true;
      console.log("node vperson is ", node.isBlackList, node.pStatusId);
      if (node.isBlackList == 39) {
        this.$root.root_validate_errors.push(this.$t('isInBlacklist'));
        valid = false;
      }
      if (node.pStatusId == 40) {
        this.$root.root_validate_errors.push(this.$t('isDectivated'));
        valid = false;

      }
      var self = this;
      if (!valid) {
        setTimeout(function () {
          self.document_person = null;
        }, 200);
      }
    },

    cancel_edit_product() {
      this.selected_product = null;
      this.product_count = '';
      this.product_price = '';
      this.product_off = '';
      this.product_tax = '';
      this.status_product_form = -1;
    },
    open_selected_product() {
      window.open('/dashboard/products/edit/' + this.selected_product, '_blank')
    },
    another_focus(id) {
      setTimeout(function () {
        document.getElementById(id).focus()
      }, 200);
    },
    get_base_data() {

      this.get_places();
      this.get_cashiers();
      this.get_product_units();
      this.get_costs();
      this.get_currencies();
      this.get_sys();
    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;

        self.pay_type_items = [];


        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 26) {
            self.pay_type_items.push(obj);
          }


        });


        self.selected_pay_type = self.pay_type_items[0].value


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_costs() {
      var self = this;

      const formData = new FormData();

      axios.post('GetDeliveryCostItems', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          var array = [];
          for (var i = 0; i < content_data.data.length; i++) {
            if (i > 0) {
              array.push(content_data.data[i]);
            }
          }
          self.cost_items = self.sort_array(self.cost_items, array, "id", "deliveryCostTitle");
          self.selected_first_cost = self.cost_items[0].value;
          self.selected_sec_cost = self.cost_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_currencies() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysCurrencyList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.currency_items2 = []
          self.currency_items2 = self.sort_array(self.currency_items2, content_data.data, "currencyId", "currencySymbol");
          self.selected_currency = self.currency_items2[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      }).catch(function (error) {
        console.log(error);
      });

    },

    generate_total() {
      this.total_price = 0;
      var total_off = 0;
      var total_tax = 0;
      var total_pay_price = 0;
      this.total_weight = 0;
      var ratio = parseFloat(this.currency_rate);

      var factor_off = 0;
      if (this.total_factor_off_type == 1 && this.total_factor_off != '') {
        // total_off = parseFloat(this.total_factor_off);
        factor_off = parseFloat(this.total_factor_off);

      }
      this.document_result_price = [];
      this.product_items.forEach((val) => {
        if (val.name != null) {
          console.log("product is", (parseFloat(val.count) * val.weight * val.unit_value))
          total_off += this.calculate_off_price(val);
          total_tax += this.calculate_tax_price(val);
          total_pay_price += this.calculate_total_price(val);
          this.total_price += this.calculate_total_pay_price(val);
          this.total_weight += (parseFloat(val.count) * val.weight * val.unit_value);
          if (this.total_factor_off_type == 2 && val.non_off == false && this.total_factor_off_type != 0 && this.total_factor_off != '') {
            // total_off += (parseFloat(this.total_factor_off)*this.calculate_total_price(val))/100;
            factor_off += (parseFloat(this.total_factor_off) * parseFloat(this.calculate_total_price(val))) / 100;

          }
        }
      });
      this.total_price = parseFloat(this.total_price);

      if (this.delivery_cost_amount != null && this.delivery_cost_amount != "") {
        this.total_price += parseFloat(this.delivery_cost_amount);
      }
      if (this.sec_cost_amount != null && this.sec_cost_amount != "") {
        this.total_price += parseFloat(this.sec_cost_amount);
      }
      // this.total_weight = this.total_weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.document_person_remain_amount = 0;
      var obj = {
        type: localStorage.getItem('currency_name'),
        totalTitle: this.$t('totalPrice'),
        totalPrice: this.currency_with_symbol(total_pay_price),
        offPrice: this.get_currency(total_off),
        afterOffPrice: this.get_currency(total_pay_price - total_off),
        taxPrice: this.get_currency(total_tax),
        factor_off: factor_off*ratio,

        payPrice: this.currency_with_symbol(this.total_price - factor_off),
        beforePrice: this.document_person_remain_amount,
        total_weight: this.total_weight,
        finalPrice: parseFloat(this.document_person_remain_amount) + parseFloat(this.total_price)
      };
      this.document_result_price.push(obj)
      this.generate_total_currency();
    },
    generate_total_currency() {
      this.total_price = 0;
      var total_off = 0;
      var total_tax = 0;
      var total_pay_price = 0;
      var factor_off = 0;
      if (this.total_factor_off_type == 1 && this.total_factor_off != '') {
        factor_off = parseFloat(this.total_factor_off);
      }
      this.total_weight = 0;
      this.product_items.forEach((val) => {
        if (val.name != null) {
          total_off += this.calculate_off_price(val);
          total_tax += this.calculate_tax_price(val);
          total_pay_price += this.calculate_total_price(val);
          this.total_price += this.calculate_total_pay_price(val);
          this.total_weight += (parseFloat(val.count) * val.weight * val.unit_value);
          if (this.total_factor_off_type == 2 && val.non_off == false && this.total_factor_off_type != 0 && this.total_factor_off != '') {
            factor_off += (parseFloat(this.total_factor_off) * parseFloat(this.calculate_total_price(val))) / 100;
          }
        }
      });

      // this.total_weight = this.total_weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.document_person_remain_amount = 0;
      var ratio = parseFloat(this.currency_rate);
      var this_currency_title =this.currency_items2.filter(x => x.value == this.selected_currency)[0].currencyTitle
      var this_currency_symbol =this.currency_items2.filter(x => x.value == this.selected_currency)[0].currencySymbol
      var obj = {
        type: this_currency_symbol,

        totalTitle: this.$t('totalPrice'),
        totalPrice: this_currency_title+" "+this.get_currency(total_pay_price / ratio),
        offPrice: this.get_currency(total_off / ratio),
        afterOffPrice: this.get_currency((total_pay_price - total_off) / ratio),
        factor_off: factor_off,

        taxPrice: this.get_currency(total_tax / ratio),
        payPrice: this_currency_title+" "+this.get_currency(this.total_price / ratio),
        beforePrice: this.document_person_remain_amount,
        total_weight: this.total_weight,
        finalPrice: (parseFloat(this.document_person_remain_amount) + parseFloat(this.total_price)) / ratio
      };
      this.document_result_price.push(obj)
    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers = self.sort_array(
              self.cashiers, response.data.data,
              'id', 'boxTitle');
          self.selected_cashiers = self.cashiers[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    select_product(node, instance) {
      var lenght_duplicate = this.product_items.filter(x=>x.product_id == node.id ).length
      if(lenght_duplicate>0){
        this.$root.root_validate_errors.push(this.$t('dialogs.duplicateProduct'));
      }

      console.log("node is", node)
      this.product_name = node.productCodeName;
      this.product_existance = node.existence;
      // this.product_price = node.purchasePrice;
      this.product_price = "";
      this.product_weight = node.weight;
      this.product_off = "";
      this.product_non_off = node.nonOff;

      // this.product_off = node.takhfif;
      this.product_tax = "";
      // this.product_tax = node.vat;
      this.product_off_is_percent = node.isPercent;
      this.product_unit = node.productUnitId;
      this.product_unit_name = node.productUnitName;
      this.product_unit_value = node.value;
      this.product_count = 1;
      setTimeout(function () {
        document.getElementById('product_qty_input').focus()

        document.getElementById('product_qty_input').select();
      }, 150);

    },
    table_row_clicked(item, index, column, event) {
      if (event.watch == 3) {

        console.log(event);
        this.product_index_clicked = index;
        var self = this;
        setTimeout(function () {
          // self.$refs.menu.open(self.mouse_position,null)
          self.$refs.menu.open(event, null)

          // var obj = self.$refs.dropdown_menu.$el.getElementsByTagName('button')[0]
        }, 150);
      }
    },

    calculate_total_price(item) {
      var cur_ratio = this.currency_rate;
      if (cur_ratio == 0 || cur_ratio == "") {
        cur_ratio = 1;
      }
      // return item.price * item.count * item.unit_value * cur_ratio;
      return item.price * item.count  * cur_ratio;
    },
    calculate_total_price_currency(item) {
      // return item.price * item.count * item.unit_value;
      return item.price * item.count ;
    },
    calculate_off_price(item) {
      var off = 0;
      var cur_ratio = this.currency_rate;
      if (cur_ratio == 0 || cur_ratio == "") {
        cur_ratio = 1;
      }
      // if (item.product_off_is_percent == true) {
      off = parseFloat(item.product_off * cur_ratio);
      // } else {
      //   off = item.product_off * item.count * item.unit_value;

      // }
      if (!off) {
        return 0;
      }
      return off;
    },
    calculate_tax_price(item) {
      var cur_ratio = this.currency_rate;
      if (cur_ratio == 0 || cur_ratio == "") {
        cur_ratio = 1;
      }
      // return parseInt(item.product_tax * item.count * item.unit_value);
      // var tax = (item.product_tax * (this.calculate_total_price(item)-this.calculate_off_price(item))) / 100;
      var tax = (item.product_tax * cur_ratio);

      // var ret_value = (item.product_tax * this.calculate_total_price(item)) / 100;
      if (tax) {
        return tax;
      } else {
        return 0;
      }
    },
    calculate_total_pay_price(item) {
      return this.calculate_total_price(item) - this.calculate_off_price(item) + this.calculate_tax_price(item)
    },

    validateForm: function () {
      this.$root.root_validate_errors = [];


      if (this.date != '' && this.selected_place != 0 && this.document_person != null && this.product_items.length > 1) {
        return true;


      }

      if (this.date == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertDate'));
      }
      if (this.selected_place == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectWarehouse'));
      }
      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.selectedTypeLabel + this.$t('dialogs.select'));
      }
      if (this.this.product_items.length == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectProducts'));
      }

      return false;
      // e.preventDefault();
    },
    validateProduct: function () {
      this.$root.root_validate_errors = [];
      var duplicate_product = false;
      this.product_items.forEach((val) => {
        if (val.product_id == this.selected_product && this.status_product_form == -1) {
          this.$root.root_validate_errors.push(this.$t('dialogs.duplicateProduct'));
          duplicate_product = true;

        }
        // val.row_id = row_index;
        // row_index += 1;
      });

      if (this.product_name != '' && this.product_price != '' && this.product_price != null && this.product_price != '0' && this.product_count != '' && this.product_count != 0 && !duplicate_product) {
        return true;
      }

      // if (this.product_name == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      // }
      if (this.product_price == '' || this.product_price == '0' || this.product_price == null) {
        this.$root.root_validate_errors.push(this.$t('insertProductPrice'));
      }
      if (this.product_count == '' || this.product_count == "0") {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertProductQty'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    add_product_to_document_new() {
      if (this.status_product_form != -1) {
        this.update_product_to_document();
        return
      }
      console.log("validate is ", this.validateProduct())
      if (this.validateProduct()) {

        var product_new_item = [];
        // this.unit_items.forEach((val) => {
        //   if (val.id == this.product_unit) {
        //     product_new_item.unit_value = val.value;
        //     product_new_item.unit_value_name = val.unitName;
        //   }
        //   // val.row_id = row_index;
        //   // row_index += 1;
        //
        // });
        product_new_item.unit_value_name = "";
        product_new_item.unit_value = this.product_unit_value;
        product_new_item.name = this.product_name;
        product_new_item.non_off = this.product_non_off;

        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;

        product_new_item.totalPrice = this.calculate_total_price(product_new_item);
        product_new_item.offPrice = this.calculate_off_price(product_new_item);
        product_new_item.taxPrice = this.calculate_tax_price(product_new_item);
        product_new_item.totalPayPrice = this.calculate_total_pay_price(product_new_item);

        console.log('product is ', product_new_item)
        this.product_items.push(product_new_item);
        this.product_name = "";
        this.product_unit = "";
        this.product_off = "";
        this.product_tax = "";
        this.product_count = "";
        this.product_non_off = false;

        this.product_summary = '';
        this.product_price = "";
        this.selected_product = null;

        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        if (this.status_form != 0) {
          this.add_one_factor_product(this.product_items.length - 1);
        }
        console.log("productseeker ", document.getElementById("product_seeker").children[0].children[0].children[2].children[0])

        this.text_input_searcher = document.getElementById("product_seeker").children[0].children[0].children[2].children[0]

        this.text_input_searcher.focus();
      }
    },
    update_product_to_document() {
      if (this.validateProduct()) {
        // this.status_product_form = -1;
        var product_new_item = [];
        // this.unit_items.forEach((val) => {
        //   if (val.id == this.product_unit) {
        //
        //   }
        //   // val.row_id = row_index;
        //   // row_index += 1;
        //
        // });
        product_new_item.unit_value = 1;
        product_new_item.unit_value_name = "";

        if (this.status_product_form != -1) {
          // product_new_item.detail_id = this.product_items[this.status_product_form].detail_id;
          product_new_item.detail_id = this.product_items.filter(x => x.product_id == this.status_product_form)[0].detail_id;

        }
        product_new_item.non_off = this.product_non_off;

        product_new_item.name = this.product_name;
        product_new_item.unit = this.product_unit;
        product_new_item.count = this.product_count;
        product_new_item.price = this.product_price;
        product_new_item.summary = this.product_summary;
        product_new_item.weight = this.product_weight;
        product_new_item.product_id = this.selected_product;
        product_new_item.product_off = this.product_off;
        product_new_item.product_tax = this.product_tax;
        product_new_item.product_off_is_percent = this.product_off_is_percent;
        this.product_items.forEach((val, index) => {
          if (val.product_id == this.status_product_form) {
            this.product_items.splice(index, 1, product_new_item);
          }
        });
        // this.product_items.splice(this.status_product_form, 1, product_new_item);
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_off = "";
        this.product_non_off = false;

        this.product_tax = "";
        this.product_price = 0;
        this.selected_product = null;
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        if (this.status_form != 0) {
          this.edit_factor_product(this.status_product_form)

        } else {
          this.status_product_form = -1;

        }
      }
    },
    edit_item(index) {

      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      var product_new_item = this.product_items.filter(x => x.product_id == index)[0];
      console.log("edit item", product_new_item)
      this.product_non_off = product_new_item.non_off;

      this.product_name = product_new_item.name;
      this.product_unit = product_new_item.unit;
      this.product_count = product_new_item.count;
      this.product_weight = product_new_item.weight;
      this.product_price = parseFloat(product_new_item.price).toFixed(2);
      this.product_summary = product_new_item.summary;
      this.product_off = product_new_item.product_off;
      this.product_tax = product_new_item.product_tax;
      this.product_unit_value = product_new_item.unit_value;

      this.product_off_is_percent = product_new_item.product_off_is_percent;
      this.selected_product = product_new_item.product_id;
      this.status_product_form = index;
      this.get_product_data()
    },
    get_product_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetNewProductById";

      formData.append('id', this.selected_product);
      axios.post(url, formData, {}).then((res) => {


        self.product_weight = res.data.data.productExtraInfos.filter(x => x.productId == self.selected_product)[0].weight;


      }).catch(function (error) {
        console.log(error);
      });
    },
    emptyList() {
      this.$router.push({path: '/dashboard/products/list'})

    },
    get_places() {
      var self = this;
      self.places_items = [];
      this.$apis.get_places().then(result =>{
        self.places_items = result
        self.selected_place = self.places_items[0].value;

      })


    },
    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.unit_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person);


      axios.post(url, formData, {}).then((res) => {

        if (res.data.data.personJobProfile.paymentMethod == 58) {
          self.selected_pay_type = 34;
        }
        if (res.data.data.personJobProfile.paymentMethod == 59) {
          self.selected_pay_type = 35;
        }

        self.document_person_remain_amount = res.data.data.mande;
        self.document_person_method_name = res.data.data.methodName;


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    insert_data_factor() {
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;

      if (this.status_form == 0) {
        url = "AddFactor";
      } else {
        url = "EditFactorMaster";
        formData.append('Id', this.status_form)

      }

      // StatusId
      // DocDesc
      // Id
      // CreatedBy
      // BaseFactorId
      //
      var json_cost = [];
      if (this.delivery_cost_amount != '' && this.delivery_cost_amount != '0') {
        json_cost.push({DeliveryCostId: 1, DeliveryCostPrice: this.delivery_cost_amount});
      }
      if (this.sec_cost_amount != '' && this.sec_cost_amount != '0') {
        json_cost.push({DeliveryCostId: this.selected_sec_cost, DeliveryCostPrice: this.sec_cost_amount});
      }
      formData.append('PayType', this.selected_pay_type);
      formData.append('AccountId', this.selected_cashiers);
      formData.append('BaseFactorId', 0);
      formData.append('DocDate', this.date);
      formData.append('PartyId', this.document_person);
      formData.append('PlaceId', this.selected_place);
      formData.append('DocType', 7);
      formData.append('DeliveryType', this.delivery_type);
      formData.append('DocDesc', this.document_summary);
      formData.append('DeliveryCostList', JSON.stringify(json_cost));
      formData.append('CurrencyId', this.selected_currency);
      formData.append('CurrencyRate', this.currency_rate);
      formData.append('Shelf', this.product_location);
      formData.append('DeliveryType', 0);

      formData.append('FactorDiscountType', this.total_factor_off_type);
      var total_percent_price_off = 0;
      if (this.total_factor_off == '') {
        this.total_factor_off = '0';
      }
      if (this.total_factor_off_type == 2) {
        this.product_items.forEach((val) => {
          if (val.name != null) {
            if (val.non_off == false && this.total_factor_off != '') {
              total_percent_price_off += (parseFloat(this.total_factor_off) * this.calculate_total_price(val)) / 100;
            }
          }
        });
        formData.append('FactorDiscount', total_percent_price_off);
      } else {
        formData.append('FactorDiscount', this.total_factor_off);

      }
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {

          self.master_id = res.data.data.id;
          self.insert_factor_products();

          // self.product_items.forEach((val) => {
          //     self.insert_factor_products(index);
          //     index+=1;
          //
          // });

        } else {
          self.$router.push({path: "/dashboard/documents/show/" + self.status_form})
        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    insert_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddFactorDetail";
      } else {
        url = "EditFactorDetail";
        formData.append('Id', this.status_form)

      }

      var sending_products = [];
      var pr_index = 0;
      self.product_items.forEach((val) => {
        if (pr_index != 0) {
          var pro_obj = {
            MasterId: self.master_id, PlaceId: self.selected_place,
            ProductId: val.product_id, ProductUnitId: val.unit, Qty: val.count * self.selectedTypeQty,
            Price: (val.price/val.unit_value), ProductDesc: val.summary,
            Tax: val.product_tax*this.currency_rate,
            Discount: val.product_off*this.currency_rate
          };
          sending_products.push(pro_obj);
        }
        pr_index = 1;
      });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;

          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_one_factor_product(index) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "AddFactorDetail";

      var sending_products = [];
      // self.product_items.forEach((val) => {

      var pro_obj = {
        MasterId: self.status_form,
        PlaceId: self.selected_place,
        ProductId: self.product_items[index].product_id,
        ProductUnitId: self.product_items[index].unit,
        Qty: self.product_items[index].count * self.selectedTypeQty,
        Price: self.product_items[index].price,
        ProductDesc: self.product_items[index].summary
      };
      sending_products.push(pro_obj);
      // });
      var final_sending = {'details': sending_products};
      formData.append('model', JSON.stringify(final_sending));
      // formData.append('PlaceId', this.selected_place);
      // formData.append('ProductId', this.product_items[index].product_id);
      // formData.append('ProductUnitId', this.product_items[index].unit);
      // formData.append('Qty', this.product_items[index].count * this.selectedTypeQty);
      // formData.append('Price', this.product_items[index].price);
      // formData.append('ProductDesc', this.product_items[index].summary);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;

          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_factor_product(index) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "EditFactorDetail";

      // self.product_items.forEach((val) => {
      var edited_product = this.product_items.filter(x => x.product_id == this.status_product_form)[0];


      // });
      // var final_sending = {'details': sending_products};
      // formData.append('model', JSON.stringify(final_sending));

      // });
      // var final_sending = {'details': sending_products};
      // formData.append('model', JSON.stringify(final_sending));
      formData.append('MasterId', self.status_form);
      formData.append('Id', edited_product.detail_id);
      formData.append('PlaceId', this.selected_place);
      formData.append('ProductId', edited_product.product_id);
      formData.append('ProductUnitId', edited_product.unit);
      formData.append('Qty', edited_product.count * this.selectedTypeQty);
      formData.append('Price', edited_product.price / edited_product.unit_value);
      formData.append('ProductDesc', edited_product.summary);
      formData.append('Tax', edited_product.product_tax*this.currency_rate);
      formData.append('Discount', edited_product.product_off*this.currency_rate);
      formData.append('CurrencyId', self.selected_currency);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {
          self.date = "";
          self.document_person = null;
          self.document_summary = "";
          // if (index == self.product_items.length - 1) {
          self.product_items = [];
          self.selected_place = 0;
          self.status_product_form = -1;
          self.name = "";
          self.meli_code = "";
          self.meli_code = "";
          self.mobile = "";
          self.phone_no = "";
          self.isWorker = false;
          self.isCustomer = false;
          self.isVendor = false;
          self.selected_province = 0;
          self.selected_city = 0;
          self.selected_area = 0;
          self.address = "";
          self.password = "";
          self.selected_permission_group = 0;
          self.user_location_lat = 0;
          self.user_location_lng = 0;
          self.$router.push({path: "/dashboard/documents/show/" + self.master_id})
          // }else {
          // this.$router.push({path:'/dashboard/products/list'})
          // self.insert_factor_products(index+1);

          // }
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);


      this.status_product_form = item.product_id;

    },
    delete_item() {
      if (this.status_form == 0) {

        this.product_items.forEach((val, index) => {
          if (val.product_id == this.status_product_form) {

            this.product_items.splice(index, 1);
          }
        });

        // this.product_items.splice(this.status_product_form, 1);
        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
        this.product_name = "";
        this.product_unit = "";
        this.product_count = "";
        this.product_summary = '';
        this.product_price = 0;
        this.selected_product = null;

        this.status_product_form = -1;
      } else {
        this.delete_factor_products();

      }

    },
    get_document_master() {
      var self = this;
      console.log("route id " + this.$route.params.edit_doc_id);

      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}


          self.selectedType = content_data.data.docType;
          self.document_person_name = content_data.data.partyName;
          self.document_person = content_data.data.partyId;
          self.total_factor_off_type = content_data.data.factorDiscountType;
          self.total_factor_off = content_data.data.factorDiscount;
          if (self.total_factor_off == '0') {
            self.total_factor_off = '';
          }
          self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
          self.selected_place = content_data.data.placeId;
          self.document_summary = content_data.data.docDesc;
          self.document_visitor = content_data.data.createdBy;
          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.product_location = content_data.data.shelf;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;
          self.selected_currency = content_data.data.factorMasterCurrencies[0].currencyId
          self.currency_rate = content_data.data.factorMasterCurrencies[0].currencyRate

          self.async_person_search = false;
          self.async_person_options = [{
            personCode: '',
            surName: '',
            mobileNo: '',
            userId: self.document_person,
            userName: self.document_person_name
          }]
          setTimeout(() => {
            // this.result.push(event.type);
            self.async_person_search = true;
          }, 1500);
          self.get_document_details();


          for (var i = 0; i < content_data.data.deliveryCostItems.length; i++) {
            if (content_data.data.deliveryCostItems[i].deliveryCostId == 1) {
              self.delivery_cost_amount = content_data.data.deliveryCostItems[i].deliveryCostPrice;
            } else {
              self.selected_sec_cost = content_data.data.deliveryCostItems[i].deliveryCostId
              self.sec_cost_amount = content_data.data.deliveryCostItems[i].deliveryCostPrice;
            }

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {


          content_data.data.forEach((val) => {
            val.weight = val.docWeight
            val.count = val.qty
            val.takhfif = val.discount
            self.add_edit_factor_product_to_document(val);
          });
          var percent_total_price = 0;
          if (self.total_factor_off_type == 2) {
            self.product_items.forEach(function (val) {
              if (val.non_off == false) {
                percent_total_price += self.calculate_total_price(val);
              }
            });
            self.total_factor_off = (self.total_factor_off * 100) / (percent_total_price)

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    add_edit_factor_product_to_document(item) {
      // ,,"productUnitId":1,"productUnitName":"کارتن 12 تایی","value":12,"qty":1,"price":"11960","docDesc":""
      var product_new_item = [];

      // this.unit_items.forEach((val) => {
      //   if (val.id == item.productUnitId) {
      //   }
      //   // val.row_id = row_index;
      //   // row_index += 1;
      //
      // });
      product_new_item.unit_value = item.value;

      product_new_item.detail_id = item.detailId;
      product_new_item.name = item.productCode + " " + item.productName;
      product_new_item.unit = item.productUnitId;
      if (item.qty < 0) {
        item.qty = item.qty * -1;
      }
      product_new_item.count = item.qty / item.value;
      product_new_item.price = parseFloat(item.price / this.currency_rate);
      product_new_item.weight = item.weight;
      product_new_item.product_off = parseFloat(item.takhfif/ this.currency_rate);
      product_new_item.product_tax = parseFloat(item.tax/ this.currency_rate);
      product_new_item.product_off_is_percent = true;
      product_new_item.summary = item.docDesc;
      product_new_item.product_id = item.productId;
      product_new_item.non_off = item.nonOff;

      product_new_item.totalPrice = this.calculate_total_price(product_new_item);
      product_new_item.offPrice = this.calculate_off_price(product_new_item);
      product_new_item.taxPrice = this.calculate_tax_price(product_new_item);
      product_new_item.totalPayPrice = this.calculate_total_pay_price(product_new_item);

      this.product_items.push(product_new_item);
      var row_index = 0;
      this.product_items.forEach((val) => {
        val.row_id = row_index;
        row_index += 1;

      });

    },
    delete_factor_products() {

      let self = this;
      const formData = new FormData();
      let url;

      url = "DeleteFactorDetail";
      // formData.append('Id', this.product_items[this.status_product_form].detail_id)
      formData.append('Id', this.product_items.filter(x => x.product_id == this.status_product_form)[0].detail_id)

      // formData.append('model', JSON.stringify(final_sending));

      axios.post(url, formData, {}).then((res) => {


        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          this.product_items.splice(this.status_product_form, 1);
          var row_index = 0;
          this.product_items.forEach((val) => {
            val.row_id = row_index;
            row_index += 1;

          });
          this.product_name = "";
          this.product_unit = "";
          this.product_count = "";
          this.product_summary = '';
          this.product_price = 0;
          this.selected_product = null;

          this.status_product_form = -1;

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}

</script>
